import { useContext } from 'react'
import * as ROUTES from 'Routes'
import { ROOT_URL } from 'gatsby-env-variables'
import { navigate } from 'gatsby'
import { Form, Formik } from 'formik'
import classNames from 'classnames'
import 'react-loading-skeleton/dist/skeleton.css'
import removeSpecialChars from '@mobi/utils/formatters/removeSpecialChars'
import cpfMask from '@mobi/utils/masks/cpf'
import cnpjMask from '@mobi/utils/masks/cnpj'
import Text from 'components/Text'
import Button from 'components/Button'
import ImgStoryblok from 'components/ImgStoryblok'
import { InputText } from 'components/Fields'
import useMediaQuery from 'hooks/useMediaQuery'
import { ThemeContext } from 'modules/Theme'
import storage from 'utils/storage'
import analytics from '@mobi/libraries/analytics'
import './LandingHero.scss'

const LandingHero = ({ blok, location }) => {
  const isNotMobile = useMediaQuery('notMobile')
  const { theme } = useContext(ThemeContext)

  const renderInputCpfCnpj = () => {
    return (
      <div className="hero-input-container">
        <Formik
          initialValues={{ document: '' }}
          onSubmit={(values) => {
            const documentNumber = values.document
            const leadType =
              documentNumber && removeSpecialChars(documentNumber).length > 11
                ? 'PJ'
                : 'PF'
            storage.session.setItem('leadType', leadType)

            analytics.track('formStarted')

            navigate(ROUTES.register.path, {
              state: {
                document: values.document,
                source_url: location.href,
              },
            })
          }}
        >
          {({ ...formProps }) => {
            return (
              <Form className="form-content">
                <InputText
                  name="document"
                  placeholder={'Digite seu CPF ou CNPJ'}
                  mask={(e) => {
                    if (e && removeSpecialChars(e).length <= 11) return cpfMask
                    else return cnpjMask
                  }}
                  rules={{ isCpfOrCnpj: true, isRequired: true }}
                  inputMode="numeric"
                  dataTest="input-document"
                  {...formProps}
                />
                {/* <InputText
                    name="document"
                    placeholder="Insira seu CPF"
                    mask={cpfMask}
                    rules={{ isCpf: true, isRequired: true }}
                    inputMode="numeric"
                    {...formProps}
                  /> */}
                <div className="button-container">
                  <Button
                    className="button"
                    type="submit"
                    data-unique="63a2d907-4325-4e21-a45f-d420493b4f10"
                    data-test="button-submit-document"
                    data-make-location="hero"
                    data-make-position="hero-cta"
                    data-make-actionoutcome="check_cpf"
                    data-make-element="button"
                    data-make-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
                  >
                    {blok.button_text}
                  </Button>
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    )
  }

  const heroClassnames = classNames('landing-hero', {
    'landing-hero__generalTheme': theme !== 'recovery',
  })

  return (
    <div className="hero-container">
      <div className={heroClassnames}>
        <div className="hero-left-part">
          <Text p size={1} className="label-text description-text">
            {blok.top_text}
          </Text>
          <Text h1 size={3} className="hero-main-text">
            {blok.middle_text}
            <div className="inline highlight-text">{` ${blok.middle_text_blue}`}</div>
          </Text>
          {renderInputCpfCnpj()}
        </div>
        {isNotMobile && (
          <div className="right-part">
            <ImgStoryblok
              src={blok.image.filename}
              alt={blok.image.alt}
              preload
              dataTest="hero-image"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default LandingHero
